import { useOutletContext } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react"
import PageTitle from "../components/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import ApiCall from "../common/ApiCall";
import { setLoading, setLogout } from "../redux/user/user.action";
import { useNavigate } from "react-router-dom";
import Index from "../view/Booking/Index";
import { confirmAlert } from 'react-confirm-alert'; // Import
import ToastAlert from "../common/ToastAlert";
import CancelConfirmation from "../view/Booking/CancelConfirmation";
import helper, { generateCancellationPolicyDateFormat, getSlugByLang } from "../common/Helper";
import axios from "axios";
import HomeIcon from "../components/Iocns/HomeIcon";


export default function BookingController({ view }) {
    const [setBreadcrumbList] = useOutletContext();
    const user = useSelector((state) => state.user);
    const [bookingList, setBookingList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [showModal, setShowModal] = useState(false);
    const [cancelId, setCancelId] = useState(null);
    const [cancellationPolicy, setCancellationPolicy] = useState("");
    const [isDownloading, setIsDownloading] = useState("");
    const [whatsappNumber, setWhatsappNumber] = useState("");
    let sl = getSlugByLang(user?.language)
    const [isOpenBookingId, setIsOpenBookingId] = useState("");
    const [isOpenBooking, setIsOpenBooking] = useState(false);


    const toggleDetails = (id) => {
        setIsOpenBookingId(id);
        setIsOpenBooking(isOpenBookingId == id ? !isOpenBooking : true)
    };


    const getBookingList = async (page = currentPage) => {
        setIsLoading(true)
        let data = {}
        data.page = page
        data.limit = limit
        data.type = view

        const recordList = await ApiCall('post', 'bookings', data, user.token)
        setIsLoading(false)
        if (recordList) {
            if (recordList?.data?.success) {
                setBookingList(recordList.data.data);
                setTotalPages(recordList.data.last_page);
                setTotalItems(recordList.data.total)
                setWhatsappNumber(recordList.data.whatsappNumber)


            } else {
                if (recordList.data.message == 'Unauthorized' || recordList.data.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + sl + '/login')
                }

            }
        }

    }

    useEffect(() => {
        (async () => {
            await getBookingList(1);
            setCurrentPage(1);
        })();
    }, [view]);


    const onPageChange = async (page) => {
        setCurrentPage(page);
        await getBookingList(page);
    };


    useEffect(() => {

        setBreadcrumbList([
            {
                name: <HomeIcon />,
                url: "/" + sl
            },
            {
                name: "Bookings"
            },
        ])
    }, []);

    // const requestCancellation = (id) => {

    //     confirmAlert({
    //         customUI: ({ onClose }) => {
    //             return (
    //                 <div className='custom-ui'>
    //                     <h1>Are you sure?</h1>
    //                     <p>You want to cancel this booking?</p>
    //                     <button onClick={onClose}>No</button>
    //                     <button
    //                         onClick={async () => {
    //                             onClose()
    //                             dispatch(setLoading(true))
    //                             const reqCan = await ApiCall('get', 'bookings/cancel-request/' + id, null, user.token)
    //                             dispatch(setLoading(false))
    //                             if (reqCan && reqCan.data.success) {
    //                                 await getBookingList(1);
    //                                 ToastAlert({ msg: reqCan.data.message, msgType: 'success' });
    //                             } else {
    //                                 if (reqCan.data.message == 'Unauthorized' || reqCan.data.error == 'Unauthorized') {
    //                                     dispatch(setLogout())
    //                                     navigate('/login')
    //                                 }
    //                                 ToastAlert({ msg: reqCan.data.message, msgType: 'error' });
    //                             }
    //                         }}
    //                     >
    //                         Yes
    //                     </button>
    //                 </div>
    //             );
    //         }
    //     });

    // }
    useEffect(() => {
        if (showModal == false) {
            setCancelId(null)
            setCancellationPolicy("")
        }
    }, [showModal]);

    const requestCancellation = (id, policy, date, time, timeZone) => {
        setCancelId(id)
        setShowModal(true)
        setCancellationPolicy(generateCancellationPolicyDateFormat(policy, date, time, timeZone))

    }

    const onClickYes = async () => {
        dispatch(setLoading(true))
        const reqCan = await ApiCall('get', 'bookings/cancel-request/' + cancelId, null, user.token)
        dispatch(setLoading(false))
        if (reqCan && reqCan?.data?.success) {
            setShowModal(false)
            setCancelId(null)
            await getBookingList(1);
            ToastAlert({ msg: reqCan.data.message, msgType: 'success' });
        } else {
            if (reqCan?.data?.message == 'Unauthorized' || reqCan?.data?.error == 'Unauthorized') {
                dispatch(setLogout())
                navigate('/' + sl + '/login')
            }
            ToastAlert({ msg: reqCan?.data?.message, msgType: 'error' });
        }

    }

    const downloadTicket = async (id) => {
        try {
            setIsDownloading(id)
            const response = await axios.post(
                helper.ApiUrl + 'bookings/genrate-tickets',
                { bookingId: id },
                {
                    headers: {
                        'Authorization': `Bearer ${user.token}`,
                        'Accept': 'application/json',
                    },
                }
            );

            if (!response?.data?.success) {
                ToastAlert({ msg: response?.data?.message, msgType: 'error' });
                return false
            }

            const url = response.data.url;

            if (url) {
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url + '&response-content-disposition=attachment';
                document.body.appendChild(iframe);

                // Clean up after 1 second
                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 1000);
                setIsDownloading("")
            } else {
                setIsDownloading("")
                console.error('No URL returned');
            }
        } catch (error) {
            setIsDownloading("")
            console.error('Download failed:', error);
        }
    };

    const chatOnWhatsapp = (bookingId) => {
        const phoneNumber = whatsappNumber;
        if (phoneNumber) {
            const message = 'Booking Id #' + bookingId;
            const encodedMessage = encodeURIComponent(message);
            const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
            window.open(url, '_blank');
        } else {
            ToastAlert({ msg: "Apologies for the inconvenience. This service is unavailable at the moment.", msgType: 'info' });

        }
    }

    return (
        <>
            <PageTitle title="Bookings" />
            <Index
                bookingList={bookingList}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                isLoading={isLoading}
                totalItems={totalItems}
                view={view}
                requestCancellation={requestCancellation}
                downloadTicket={downloadTicket}
                isDownloading={isDownloading}
                chatOnWhatsapp={chatOnWhatsapp}
                userlang={sl}
                toggleDetails={toggleDetails}
                isOpenBooking={isOpenBooking}
                isOpenBookingId={isOpenBookingId}
            />
            <CancelConfirmation
                showModal={showModal}
                setShowModal={setShowModal}
                onClickYes={onClickYes}
                cancellationPolicy={cancellationPolicy}
            />
        </>
    )
}